import { ApiService } from "../api";
import { Promo } from "./Promo";

/**
 * Functions for working with promos.
 */
export class PromoService {
	protected apiService: ApiService;

	constructor() {
		this.apiService = new ApiService();
	}

	/**
	 * Find all promos
	 */
	public async findAll(): Promise<Promo[]> {
		const promoData = await this.apiService.get("/api/v1/promos");
		const promos = await promoData.json();

		return Promo.fromJsonArray(promos);
	}

	public async save(promo: Promo): Promise<Promo> {
		const promoData = await this.apiService.post(
			`/api/v1/promo/${promo.id}`,
			promo,
		);
		const updatedPromo = await promoData.json();
		return Promo.fromJson(updatedPromo);
	}

	public async create(promo: Promo): Promise<Promo> {
		const promoData = await this.apiService.post(`/api/v1/promos`, promo);
		const newPromo = await promoData.json();
		return Promo.fromJson(newPromo);
	}
}
